import config from '../../config/config';
import { reduxStore } from '../../index';
import { createUserSession, closeUserSession } from '../../app/data/actions/session';

const SESSION_KEY = "pt.deliverytracker.key.session"


/**
 * Store Authentication information on the window object
 *
 * @param query
 */
function createSession(query) {
    var session = {};
    session['user'] = query.user;
    session['store_id'] = query.store_id;
    session['tS'] = query['tS'];
    session['ts'] = query['ts'];
    session['md5'] = query.md5;

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));

    reduxStore.dispatch(createUserSession(session));

    return session;
}


function getSession() {

    let session = {};

    if (config.mock && config.mock === true) {
        console.debug("getSession: Using mock session")
        session['user'] = "Anomynous";
        session['store_id'] = 999;
        session['tS'] = 10000000000;
        session['ts'] = 10000000000;
        session['md5'] = "####################";

        return session;
    }

    let sessionStr = sessionStorage.getItem(SESSION_KEY);

    if (sessionStr) {
        session = JSON.parse(sessionStr);
    }

    return session;
}

function clearSession() {
    let currentSession = getSession();
    sessionStorage.clear();
    reduxStore.dispatch(closeUserSession())
    return currentSession;
}

function getLoginUser() {
    var session = getSession();
    if (session !== undefined && session != null) {
        return session['user'];
    }
}


function getLoginStoreId() {
    var session = getSession();
    if (session !== undefined && session != null) {
        return session['store_id'];
    }
}

/**
 * Merge two array with no duplicated entries
 * @param update, entries in this array will be used in the case of equal entries
 * @param base, base or current array
 * @returns {Array} merged result of entries
 */
function mergeArraysDistinct(update, base) {
    if (!Array.isArray(update)) {
        return base;
    }

    update.sort((a, b) => {
        return a.id - b.id
    });

    base.sort((a, b) => {
        return a.id - b.id
    });

    let i0 = 0;
    let i1 = 0;


    var result = [];

    while (i0 < update.length || i1 < base.length) {
        let v0 = i0 < update.length ? update[i0].id : Number.MAX_VALUE;
        let v1 = i1 < base.length ? base[i1].id : Number.MAX_VALUE;
        if (v0 > v1) {
            result.push(base[i1]);
            i1++;
        } else {
            result.push(update[i0]);
            i0++;
            if (v0 === v1) {
                i1++;
            }
        }
    }

    return result;

}


export default {
    createSession,
    clearSession,
    getSession,
    getLoginUser,
    getLoginStoreId,
    mergeArraysDistinct,
};